import { api } from '@/services';

export default {
  async fetchAllUsuarios() {
    const params = new URLSearchParams();

    params.append('page', 1);
    params.append('perPage', 500);

    const response = await api.get('/usuario', { params });

    return response.data.registros.data;
  },
  async prepararExcel() {
    const { data } = await api.get('/usuario/excel');

    return data;
  },
  updateUserData({ commit }, payload) {
    commit('SET_USERDATA', payload);
  },
  async fetchUsuarios({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/usuario', { params });
    commit('SET_USUARIOS', response.data.registros.data);
    commit('paginacao/SET_PAGINADOR', response.data.registros, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  deleteUsuario(_, { id }) {
    return api.delete(`/usuario/${id}`);
  },
  reenviarAcesso(_, usuario) {
    return api.post('/autenticacao/recuperar', { email: usuario.email });
  },
  async getUsuarioById(_, id) {
    return api.get(`/usuario/${id}`);
  },
  async salvar(_, userData) {
    return api.post('/usuario/', userData);
  },
  async editarUsuario(_, userData) {
    return api.put(`/usuario/${userData.id}`, userData);
  },
  marcarStatusTour(_, payload) {
    return api.post('/usuario/marcar-tour', payload);
  },
  fetchTour(_, payload) {
    return api.get(`/usuario/tour/${payload}`);
  },
  async fetchUsuarioTermsConditions({ commit }) {
    const response = await api.get('/usuario/config/terms-conditions/');
    commit('SET_USUARIO_TERMS_CONDITIONS', response.data);
  },
  updateTermsConditions({ commit }, payload) {
    api.post('usuario/config/terms-conditions/', payload);
    commit('SET_USUARIO_TERMS_CONDITIONS', true);
  },
};
